export default __webpack_public_path__ + "static/media/coin_100gm.c426b4f3.jpg";